import React from 'react';
import { BuyButton } from './BuyButton';
import { images } from '../data/siteConfig';
export function FinalCtaSection() {
  return <section className="bg-mist py-16 lg:py-24" data-id="element-38" data-mp="3lsvenmukymw2">
      <div className="mx-auto grid max-w-5xl items-center gap-10 px-5 lg:grid-cols-[1fr_0.6fr]" data-id="element-39" data-mp="3qtswfybohex1">
        <div className="text-center lg:text-left" data-id="element-40" data-mp="3vscgft6pogmr">
          <h2 className="font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-41" data-mp="3vs472b9srtgb">
            Make Your Next Pool-Care Step a Clear One.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink" data-id="element-42" data-mp="3335hit3chp0z">
            Get the visual guide, practical checklists, and all five bonus PDFs in one complete pack.
          </p>
          <div className="mt-8" data-id="element-43" data-mp="3cu9ytzghtlyz">
            <BuyButton label="GET MY POOL CARE PACK — $33" data-id="element-44" data-mp="3cujp7o5g9v57" />
          </div>
          <p className="mt-4 text-sm text-ink" data-id="element-45" data-mp="2ff5vu7kw4ot9">
            One-Time Payment · Digital PDFs · 10-Day Money-Back Guarantee
          </p>
        </div>
        <img src={images.bundleMockup} alt="The complete pool care pack" className="mx-auto hidden w-full rounded-3xl lg:block" data-id="element-46" data-mp="2kbcrn7jkojxh" />
      </div>
    </section>;
}